import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { GroupOrderShareContent, Modal } from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export const BagGroupOrderShareModal = (props: Props) => {
  const { visible, joinCode, onClose } = props;

  const { formatMessage } = useIntl();

  return (
    <Modal
      visible={visible}
      size="medium"
      fitHeight
      onRequestClose={onClose}
      accessibilityLabel={formatMessage(messages.accessibilityLabel)}
    >
      <GroupOrderShareContent joinCode={joinCode} onClose={onClose} onDone={onClose} />
    </Modal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accessibilityLabel: {
    defaultMessage: 'Invite others',
    description: 'Bag | Group order share modal | Accessibility label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  visible: boolean;
  joinCode: string;
  onClose: () => void;
};
